import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { MDXRemoteSerializeResult } from "next-mdx-remote";

export interface StrapiCookieCategoryDTO extends StrapiDynamicZoneComponentDTO {
  title: string;
  slug: string;
  description: string;
  signalGroup:
    | "Necessary"
    | "Analytics"
    | "Advertising"
    | "Functionality"
    | "Personalization";
  disabled: boolean;
  preSelected: boolean;
}

export class CookieCategoryDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  title: string;
  slug: string;
  description: MDXRemoteSerializeResult;
  signalGroup:
    | "Necessary"
    | "Analytics"
    | "Advertising"
    | "Functionality"
    | "Personalization";
  disabled: boolean;
  preSelected: boolean;
}
